import { useAxios } from "utils/axiosHook";

const useGetSections = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      url: "management/sections",
      method: "GET",
    },
    { manual: true }
  );

  const service = () => {
    return api();
  };

  return { data, loading, error, service };
};

const useAddSection = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      url: "management/sections",
      method: "POST",
    },
    { manual: true }
  );

  const service = (data) => {
    return api({ data: data });
  };

  return { data, loading, error, service };
};

const useUpdateSection = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      url: "management/sections",
      method: "PUT",
    },
    { manual: true }
  );

  const service = (data) => {
    return api({ data: data });
  };

  return { data, loading, error, service };
};

const useDeleteSections = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      url: "management/sections",
      method: "DELETE",
    },
    { manual: true }
  );

  const service = (data) => {
    return api({ data: data });
  };

  return { data, loading, error, service };
};

export { useGetSections, useAddSection, useUpdateSection, useDeleteSections };
